import type { FlexProps } from '@chakra-ui/react';
import { Button, Flex, Icon, Text } from '@chakra-ui/react';
import type { GardenView } from '@ui/utils/garden';
import {
  GARDEN_VIEWS,
  getViewIcon,
  getViewName,
  isButtonActive,
} from '@ui/utils/garden';
import { ColorThemeVars } from '@veno-app/chakra';
import React from 'react';

import { useGardenModalStore } from './useGardenModalStore';

type GardenModalActionsProps = FlexProps & {
  activeView: GardenView;
};

function GardenModalActions({ activeView, ...props }: GardenModalActionsProps) {
  const setActiveView = useGardenModalStore((s) => s.setActiveView);

  return (
    <Flex justify="center" gap="62px" {...props}>
      {GARDEN_VIEWS.map((g) => {
        const active = isButtonActive(g, activeView);
        return (
          <Flex key={g} flexDir="column" gap="3px" align="center">
            <Button
              variant="smallCard"
              isActive={active}
              rounded="full"
              color={
                active
                  ? `var(${ColorThemeVars.tabColorActive})`
                  : `var(${ColorThemeVars.tabColor})`
              }
              onClick={() => {
                setActiveView(g);
              }}
            >
              <Icon
                as={active ? getViewIcon(g).active : getViewIcon(g).normal}
              />
            </Button>
            <Text
              textStyle={{
                base: active ? 'captionBold' : 'caption',
                desktop: active ? 'bodyBold' : 'body',
              }}
              color={
                active
                  ? `var(${ColorThemeVars.parentTabColorActive})`
                  : `var(${ColorThemeVars.parentTabColor})`
              }
            >
              {getViewName(g)}
            </Text>
          </Flex>
        );
      })}
    </Flex>
  );
}

export default GardenModalActions;
